import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { CountUp } from 'countup.js';

if($('.donation-stats').length) {

    $('.donation-stats').each(function () {

        let donationSlider = $(this).find('.donor-name-scroller');

        if(donationSlider.length) {

            let donationScroller = new Swiper('.donor-name-scroller', {
                modules: [Navigation, Pagination, Autoplay],
                spaceBetween: 0,
                centeredSlides: true,
                speed: 8000,
                autoplay: {
                    delay: 0,
                },
                loop: true,
                slidesPerView:'auto',
                allowTouchMove: false,
                disableOnInteraction: true
            });

        }

    });

}

let countUpItems = $('.count-up-value');

if(countUpItems.length) {

    countUpItems.each(function (i, e) {

        let countUpItem = $(this),
            countUpValue = countUpItem.data('value'),
            isPrice = false,
            hasPlus = false;

        if(typeof countUpValue === 'string') {
            countUpValue = countUpValue.replace(/,/g, '');
            if(countUpValue.includes('$')) {
                isPrice = true;
            }
            if(countUpValue.includes('+')) {
                hasPlus = true;
            }
            countUpValue = countUpValue.replace('$', '').replace('+', '');
            countUpValue = parseFloat(countUpValue);
        }

        let animation = new CountUp(countUpItem.attr('id'), countUpValue, {
            duration: 2,
            separator: ',',
            decimal: '.',
            prefix: (isPrice) ? '$' : '',
            suffix: (hasPlus) ? '+' : '',
            enableScrollSpy: true,
            scrollSpyDelay: 500,
            scrollSpyOffset: -500,
            scrollSpyOnce: true
        });

        if (!animation.error) {
            if(countUpItem.closest('.animate').length) {
                let checkInterval = setInterval(function () {
                    if(countUpItem.closest('.animate').hasClass('animated')) {
                        animation.start();
                        clearInterval(checkInterval);
                    }
                }, 1000);

            } else {
                animation.start();
            }
        } else {
            console.error(animation.error);
        }

    });

}
